//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../no/PDM.js";
let d=[[[0,"BomScope",1,0],[0,"ProjectName",1,0],[0,"TcFolderBrowser",1,0],[0,"Type",1,0]],[[["aspectNodes"],"SetAspectsListForPartialBOM",{},1,0],[[],"SetAspectsListForFullBOM",{},0,0],[["partOperationCreateBuilder"],"SetNewBOMProperties",{},1,0],[[],"GetNewBOMProperties",{R_:{partOperationCreateBuilder:"PDM.PartOperationCreateBuilder"}},0,0],[["bomItem"],"SetBomItemToUpdate",{},1,0]],[]];
SPLM.AME.CreateBOMBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.CreateBOMBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.CreateBOMBuilder.BomScopes = Object.freeze({
    "EntireProject" : "EntireProject", "Partial" : "Partial"});

SPLM.AME.CreateBOMBuilder.Types = Object.freeze({
    "CreateNew" : "CreateNew", "Update" : "Update"});

export default SPLM;